module.exports = __webpack_public_path__ + "static/media/RENAULT_LOGO_english.5596783d.png";